// @ts-nocheck
const TranslatorProfileSkeleton = () => {

    return (
        <div>Es lädt...</div>
    )
}

export default TranslatorProfileSkeleton